/**
 * 창 맨 위 줄.
 * macOS 오버레이에서는 빈 곳을 드래그해 창을 옮기고,
 * 사이드바가 접히면 신호등이 제목 위에 오지 않게 왼쪽을 비운다.
 */
export const chromeHeaderProps = {
  "data-chrome-header": "",
  "data-tauri-drag-region": "",
} as const;
